<template>
  <div
    class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen"
  >
    <!-- Header -->
    <div class="mb-6 md:mb-8">
      <h1
        class="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 dark:text-slate-100 mb-2"
      >
        Panel de Administración
      </h1>
      <p class="text-sm md:text-base text-slate-600 dark:text-slate-400">
        Vista general del hotel - {{ fechaActual }}
      </p>
    </div>

    <!-- Filtro de Turno -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-6 md:mb-8"
    >
      <h2
        class="text-base font-semibold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2"
      >
        <i class="bx bx-filter-alt text-custom-primary"></i> Filtro de Turno
      </h2>
      <div class="flex flex-wrap gap-4 items-end">
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Desde</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hasta</label
          >
          <input
            type="datetime-local"
            v-model="filtro.fechaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <button
          @click="cargarStats"
          class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0"
        >
          <i class="bx bx-refresh mr-1"></i>Actualizar
        </button>
      </div>
    </div>

    <!-- Quick Actions (shortcuts) -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6 md:mb-8"
    >
      <h2
        class="text-lg md:text-xl font-semibold text-slate-800 dark:text-slate-100 mb-4 md:mb-6"
      >
        Acciones Rápidas
      </h2>
      <div
        class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4"
      >
        <button
          @click="$router.push('/reporte-pagos-dia')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-file text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Reportes</span
          >
        </button>
        <button
          @click="$router.push('/reportes-hotel')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-calendar text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Reservas</span
          >
        </button>
        <button
          @click="$router.push('/gestion-empleados')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-group text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Empleados</span
          >
        </button>
        <button
          @click="$router.push('/gestion-habitaciones')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-hotel text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Habitaciones</span
          >
        </button>
        <button
          @click="$router.push('/gastos-generales-hotel')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-money text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Gastos</span
          >
        </button>
        <button
          @click="$router.push('/caja-chica')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-wallet text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Caja Chica</span
          >
        </button>
        <button
          @click="$router.push('/crear-codigos-descuento')"
          class="flex flex-col items-center justify-center p-3 md:p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-purchase-tag text-2xl md:text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-xs md:text-sm text-center text-slate-700 dark:text-slate-300"
            >Cupones</span
          >
        </button>
      </div>
    </div>

    <!-- Stats Grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8"
    >
      <!-- Ocupación -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div class="p-2 md:p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
            <i
              class="bx bx-bed text-2xl md:text-3xl text-blue-600 dark:text-blue-400"
            ></i>
          </div>
          <span
            class="text-xs md:text-sm font-medium text-slate-500 dark:text-slate-400"
          >
            {{ stats.ocupacion }}%
          </span>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.habitacionesOcupadas }}/{{ stats.totalHabitaciones }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Habitaciones Ocupadas
        </p>
      </div>

      <!-- Ingresos del Día -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div class="p-2 md:p-3 bg-green-100 dark:bg-green-900/30 rounded-lg">
            <i
              class="bx bx-dollar text-2xl md:text-3xl text-green-600 dark:text-green-400"
            ></i>
          </div>
          <span
            class="text-xs md:text-sm font-medium text-green-600 dark:text-green-400"
          >
            <i class="bx bx-trending-up"></i>
          </span>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          Q{{ formatNumber(stats.ingresosDia) }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Ingresos del Día
        </p>
      </div>

      <!-- Check-ins Pendientes -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div
            class="p-2 md:p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg"
          >
            <i
              class="bx bx-log-in text-2xl md:text-3xl text-yellow-600 dark:text-yellow-400"
            ></i>
          </div>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.checkInsPendientes }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Check-ins Pendientes
        </p>
      </div>

      <!-- Check-outs de Hoy -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div class="p-2 md:p-3 bg-red-100 dark:bg-red-900/30 rounded-lg">
            <i
              class="bx bx-log-out text-2xl md:text-3xl text-red-600 dark:text-red-400"
            ></i>
          </div>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.checkOutsHoy }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Check-outs de Hoy
        </p>
      </div>
    </div>

    <!-- Charts and Tables Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
      <!-- Gráfica de Ingresos -->
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4 md:mb-6">
          <h2
            class="text-lg md:text-xl font-semibold text-slate-800 dark:text-slate-100"
          >
            Ingresos Semanales
          </h2>
          <button
            @click="$router.push('/reporte-pagos-dia')"
            class="text-custom-primary hover:opacity-80 text-sm font-medium transition-opacity border-0 bg-transparent"
          >
            Ver más
          </button>
        </div>
        <div class="h-48 md:h-64 flex items-end justify-between gap-2">
          <div
            v-for="(dia, index) in stats.ingresosSemana"
            :key="index"
            class="flex-1 flex flex-col items-center"
          >
            <div
              class="w-full bg-custom-primary rounded-t-lg transition-all hover:opacity-80"
              :style="{ height: `${(dia.monto / maxIngreso) * 100}%` }"
            ></div>
            <span class="text-xs mt-2 text-slate-600 dark:text-slate-400">{{
              dia.dia
            }}</span>
          </div>
        </div>
      </div>

      <!-- Estado de Habitaciones -->
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <h2
          class="text-lg md:text-xl font-semibold text-slate-800 dark:text-slate-100 mb-4 md:mb-6"
        >
          Estado de Habitaciones
        </h2>
        <div class="space-y-3 md:space-y-4">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-3 h-3 rounded-full bg-green-500"></div>
              <span
                class="text-sm md:text-base text-slate-600 dark:text-slate-400"
                >Disponibles</span
              >
            </div>
            <span
              class="text-sm md:text-base font-semibold text-slate-800 dark:text-slate-100"
            >
              {{ stats.habitacionesDisponibles }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-3 h-3 rounded-full bg-blue-500"></div>
              <span
                class="text-sm md:text-base text-slate-600 dark:text-slate-400"
                >Ocupadas</span
              >
            </div>
            <span
              class="text-sm md:text-base font-semibold text-slate-800 dark:text-slate-100"
            >
              {{ stats.habitacionesOcupadas }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-3 h-3 rounded-full bg-yellow-500"></div>
              <span
                class="text-sm md:text-base text-slate-600 dark:text-slate-400"
                >Limpieza</span
              >
            </div>
            <span
              class="text-sm md:text-base font-semibold text-slate-800 dark:text-slate-100"
            >
              {{ stats.habitacionesLimpieza }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-3 h-3 rounded-full bg-red-500"></div>
              <span
                class="text-sm md:text-base text-slate-600 dark:text-slate-400"
                >Mantenimiento</span
              >
            </div>
            <span
              class="text-sm md:text-base font-semibold text-slate-800 dark:text-slate-100"
            >
              {{ stats.habitacionesMantenimiento }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "../../config/config.js";

export default {
  name: "DashboardAdmin",
  data() {
    // Turno hotelero: 6am hoy → 6am mañana
    const hoy = new Date();
    const inicio = new Date(hoy);
    inicio.setHours(6, 0, 0, 0);
    const fin = new Date(hoy);
    fin.setDate(fin.getDate() + 1);
    fin.setHours(6, 0, 0, 0);
    const toLocal = (d) =>
      new Date(d - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    return {
      loading: true,
      filtro: {
        fechaInicio: toLocal(inicio),
        fechaFin: toLocal(fin),
      },
      stats: {
        habitacionesOcupadas: 0,
        totalHabitaciones: 0,
        ocupacion: 0,
        ingresosDia: 0,
        checkInsPendientes: 0,
        checkOutsHoy: 0,
        habitacionesDisponibles: 0,
        habitacionesLimpieza: 0,
        habitacionesMantenimiento: 0,
        ingresosSemana: [
          { dia: "Lun", monto: 0 },
          { dia: "Mar", monto: 0 },
          { dia: "Mié", monto: 0 },
          { dia: "Jue", monto: 0 },
          { dia: "Vie", monto: 0 },
          { dia: "Sáb", monto: 0 },
          { dia: "Dom", monto: 0 },
        ],
      },
    };
  },
  computed: {
    fechaActual() {
      const opciones = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date().toLocaleDateString("es-ES", opciones);
    },
    maxIngreso() {
      const montos = this.stats.ingresosSemana.map((d) => d.monto);
      return Math.max(...montos, 1);
    },
  },
  methods: {
    formatNumber(num) {
      return new Intl.NumberFormat("es-MX").format(num);
    },
    async cargarStats() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_URL}/dashboard/admin`, {
          params: {
            fecha_inicio: this.filtro.fechaInicio,
            fecha_fin: this.filtro.fechaFin,
          },
        });

        // Actualizar stats con datos reales de la API
        this.stats.habitacionesOcupadas = response.data.habitacionesOcupadas;
        this.stats.totalHabitaciones = response.data.totalHabitaciones;
        this.stats.ocupacion = response.data.ocupacion;
        this.stats.ingresosDia = response.data.ingresosDia;
        this.stats.checkInsPendientes = response.data.checkInsPendientes;
        this.stats.checkOutsHoy = response.data.checkOutsHoy;

        // Habitaciones por estado
        const habitaciones = response.data.habitaciones;
        this.stats.habitacionesDisponibles = habitaciones.disponibles || 0;
        this.stats.habitacionesLimpieza = habitaciones.limpieza || 0;
        this.stats.habitacionesMantenimiento = habitaciones.mantenimiento || 0;

        // Ingresos semanales
        if (response.data.ingresosSemana) {
          this.stats.ingresosSemana = response.data.ingresosSemana;
        }

        this.loading = false;
      } catch (error) {
        console.error("Error cargando estadísticas:", error);
        this.loading = false;
      }
    },
  },
  mounted() {
    this.cargarStats();
  },
};
</script>
